import { render } from "./RevisionModal.vue?vue&type=template&id=522fe7f1&scoped=true"
import script from "./RevisionModal.vue?vue&type=script&lang=js"
export * from "./RevisionModal.vue?vue&type=script&lang=js"

import "./RevisionModal.vue?vue&type=style&index=0&id=522fe7f1&scoped=true&lang=css"

import exportComponent from "/app/code_base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522fe7f1"]])

export default __exports__